module.exports = __webpack_public_path__ + "jab/media/delete.ef01c7f7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/delete.svg
// module id = 95
// module chunks = 0